import Placeholder from '@tiptap/extension-placeholder'

export const EditorPlaceholder = Placeholder.configure({
  placeholder:
    'Paste your text here to rewrite, fine tune, or get suggestions on how to improve your writing',
  showOnlyWhenEditable: false,
})
